import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { newsAPI } from '../services/api';
import AdBanner from '../components/AdBanner';
import SEOHead from '../components/SEOHead';

const News = () => {
  const { data: news = [], isLoading } = useQuery({ queryKey: ['news'], queryFn: () => newsAPI.getAll().then((r) => r.data) });

  if (isLoading) {
    return (
      <>
        <SEOHead
          title="FIFA World Cup 2026 News - WorldCup Fan Planner"
          description="Latest headlines and stories about the 2026 FIFA World Cup, host cities, teams, and travel."
        />
        <div className="p-8 text-center">Loading...</div>
      </>
    );
  }

  return (
    <>
      <SEOHead
        title="FIFA World Cup 2026 News - WorldCup Fan Planner"
        description="Latest headlines and stories about the 2026 FIFA World Cup, host cities, teams, and travel."
      />
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">News</h1>

      <AdBanner className="mb-6" slot="article" />

      <div className="space-y-4">
        {news.map((n) => (
          <a key={n.id || n.title} href={n.url} target="_blank" rel="noopener noreferrer" className="block p-4 rounded-lg bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 border dark:border-gray-700 hover:ring-2 hover:ring-amber-500">
            <h3 className="font-bold text-lg">{n.title}</h3>
            <p className="text-gray-600 dark:text-gray-400 mt-1">{n.description}</p>
            <span className="text-sm text-gray-500 dark:text-gray-500">{n.source} • {n.published_at ? new Date(n.published_at).toLocaleDateString() : ''}</span>
          </a>
        ))}
      </div>
    </div>
    </>
  );
};

export default News;
